import { Component, OnInit, ViewChild } from '@angular/core';

import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid,
  ApexNonAxisChartSeries,
  ApexXAxis
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;  // Hapus union type dengan undefined
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};

@Component({
  selector: 'app-events-activities',
  templateUrl: './events-activities.component.html',
  styleUrl: './events-activities.component.css'
})
export class EventsActivitiesComponent implements OnInit {

  @ViewChild("chart") chart!: ChartComponent;
  public chartOptions!: ChartOptions;


  constructor() {
    this.initChartData();
  }


  ngOnInit(): void {

  }


  private initChartData(): void {
    this.chartOptions = {
      series: [{
        name: "Persentase",
        data: [55, 65, 75, 95, 55, 80, 65],
      }],
      chart: {
        height: 300,
        width: 450,
        type: "bar",
        events: {
          // click: function (chart, w, e) {
          //   // console.log(chart, w, e)
          // },
          click: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1");

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },

          mouseMove: function (event, chartContext, config) {
            const defaultColors = Array(7).fill("#B6D1C1"); // Membuat array dengan 7 warna default

            if (config.dataPointIndex !== -1) {
              defaultColors[config.dataPointIndex] = "#126936";
            }

            chartContext.updateOptions({
              colors: defaultColors
            }, false, false);
          },
          // mouseLeave: function(event, chartContext, config) {
          //   chartContext.updateOptions({
          //     colors: Array(7).fill("#126936")
          //   }, false, false);
          // },
        },
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        },
      },
      colors: [
        "#B6D1C1",
        "#B6D1C1",
        "#B6D1C1",
        "#B6D1C1",
        "#B6D1C1",
        "#B6D1C1",
        "#B6D1C1"
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          distributed: true,
          dataLabels: {
            position: 'top'  // Properti position dipindahkan ke sini
          },
          borderRadius: 0
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"  // Menambahkan simbol % pada label
        },
        offsetY: -25,    // Mengatur jarak label dari bar
        style: {
          fontSize: '12px',
          colors: ["#126936"], // Warna teks label
          fontWeight: 'bold'
        },
        distributed: true,
        // orientation: 'vertical'

      },
      legend: {
        show: false
      },
      grid: {
        show: true,
        position: 'back',
        borderColor: '#E6E6E6',
        xaxis: {
          lines: {
            show: false  // Nonaktifkan garis vertikal
          },
        },
        yaxis: {
          lines: {
            show: false,  // Aktifkan garis horizontal
          }
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 20
        }
      },
      xaxis: {
        categories: ['29/09', '30/09', '01/10', '02/10', '03/10', '04/10', '05/10'],
        labels: {
          rotate: -45,  // Tidak memutar label
          trim: false, // Tidak memotong label
          hideOverlappingLabels: false,
          rotateAlways: true,
          // offsetY: 5,
          style: {
            colors: [
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#B6D1C1",
              "#191919"
            ],
            cssClass: 'apexcharts-xaxis-label',
            fontSize: "12px",
            fontWeight: 'bold'
          },
          offsetY: 8,
          offsetX: 10
        },
        tickPlacement: 'on',
      },
      yaxis: {
        title: {
          text: ""
        },
        min: 0,
        max: 100,
        tickAmount: 5,
        labels: {
          formatter: function (val) {
            return val + "%"
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
            fontWeight: 'normal'
          },
          offsetX: 10
        },
        axisBorder: {
          show: true,
          color: "#E6E6E6"
        },
        axisTicks: {
          show: true,
          color: "#E6E6E6",
          width: 6,
          offsetX: 0
        },
        crosshairs: {
          show: false
        },
        opposite: false
      },

    };
  }

}
